const HarmonyCnt = {
  symbol: "ONE",
  name: "Harmony",
  meta: {
    title: "Buy Harmony | Sell Harmony | Harmony prices and charts",
    description:
      "Harmony is a Chinese blockchain platform designed to facilitate the creation and use of decentralized applications. Buy and sell Harmony at the best price, lowest commission and fastest time in Quinnic Market.",
    keywords: "Buy Harmony, sell Harmony, what is Harmony, Harmony",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه هارمونی بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید هارمونی کنید. قیمت هارمونی در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول هارمونی کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای ذخیره هارمونی می‌توانید از انواع کیف‌پول‌های معتبر استفاده کنید. از بین کیف‌پول‌های سخت افزاری، ترزور و لجر بهترین گزینه هستند. از بین کیف‌پول‌های نرم افزاری نیز می‌توانید از تراست ولت و گواردا برای نگهداری رمز ارز ONE استفاده کنید.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توان هارمونی را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن هارمونی دارید، که می‌توانید رمز ارز هارمونی خود را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا هارمونی ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "عملکرد هارمونی از زمان به وجود آمدن آن مثبت بوده و با توجه به اینکه این رمز ارز در رتبه ۸۵ بازار کریپتو از لحاظ حجم بازار است، قطعا می‌تواند جزو گزینه‌های خوب برای سرمایه‌گذاری بلند مدت باشد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Harmony",
      answer: "Buy_Harmony",
      id: "toggler1",
    },
    {
      question: "What is the best Harmony wallet?",
      answer: "Harmony_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Harmony at coinnik Market?",
      answer: "Keep_Harmony_description",
      id: "toggler3",
    },
    {
      question: "Is Harmony worth the investment?",
      answer: "Harmony_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "Harmony market statistics and information",
        subTitle: "What is Harmony?",
        content: "Harmony_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Harmony",
        content: "Harmony_history_description",
        btnTitle: "Buy and sell Harmony",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Harmony without intermediaries in coinnik Market",
        subTitle: "Buy Harmony",
        content: "Buy_Harmony_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Harmony",
        content: "Sell_Harmony_description",
        btnTitle: "Buy and sell Harmony",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Harmony analysis on the blog",
  informationTitle: "Harmony market statistics and information",
};

export default HarmonyCnt;
